import React, { Component } from 'react'
import RoomsFrame from '../../components/header/RoomsFrame'

export default class RoomsToolbar extends Component {

    state = {}

    componentDidMount() { }

    componentDidUpdate = (prevProps) => { }

    render() {

        return (
            <div className='w-100 flexc '>
                <RoomsFrame language={this.props.language}currentPage={this.props.currentPage} changeFrame={this.props.changeFrame} width={this.props.width} page={this.props.page} changePage={this.props.changePage} frame={this.props.frame} driveSections={this.props.driveSections} />
            </div>
        )
    }
}
